// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b44d18a9","418":"d04f03a3","429":"6201cbca","453":"02e786f6","550":"77c95007"}[chunkId] + ".chunk.js";
};